import { render, staticRenderFns } from "./CongelationStock.vue?vue&type=template&id=6be2dcb2&"
import script from "./CongelationStock.vue?vue&type=script&lang=js&"
export * from "./CongelationStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports